import { useJointBillServicePeriod } from "@pages/BillsPage/useJointBillServicePeriod";
import { useCurrentJointBillServicePeriodId } from "@hooks/useCurrentJointBillServicePeriodId";
import { useOverviewQuery } from "@services/overview/queries";

export const usePreviousPeriodData = (): {
  shouldDisplayUnpaidWarning: boolean;
  previousPeriodId: number;
  previousPeriodLink: string;
} => {
  const baseUrl = window.location.origin;
  const currentPeriodId = useCurrentJointBillServicePeriodId();
  const { periodId } = useJointBillServicePeriod();
  const { data: overview } = useOverviewQuery();

  const unpaidPreviousPeriodJbsIds = (overview?.jointBillServices ?? [])
    .filter((jbs) => !!jbs.previousPeriod?.displayCustomerHasToPayWarning)
    .map((jbs) => jbs.jointBillServiceId);

  const previousPeriodLink = new URL(
    `/bills/${(currentPeriodId ?? 1) - 1}`,
    baseUrl,
  );

  if (unpaidPreviousPeriodJbsIds.length) {
    const unpaidJointBillServiceIdSearchParam =
      unpaidPreviousPeriodJbsIds.reduce((searchParams, jbsId) => {
        searchParams.append("open", jbsId.toString());
        return searchParams;
      }, new URLSearchParams());

    if (unpaidJointBillServiceIdSearchParam) {
      previousPeriodLink.search =
        unpaidJointBillServiceIdSearchParam.toString();
    }
  }

  return {
    shouldDisplayUnpaidWarning:
      periodId === currentPeriodId && !!unpaidPreviousPeriodJbsIds.length,
    previousPeriodId: (currentPeriodId ?? 1) - 1,
    previousPeriodLink: previousPeriodLink.toString(),
  };
};
